/** @format */
import React from 'react';
import {makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow} from '@material-ui/core';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { DiscountCollectionInterface } from '../../../interfaces/api/DiscountCollectionInterface';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import { DiscountInterface }     from '../../../interfaces/billing/DiscountInterface';
import CustomTextButtom          from '../../../components/Buttons/CustomTextButton';
import { DiscountHelper }        from '../../../helpers/DiscountHelper';
import { DateHelper }            from '../../../helpers/DateHelper';
import I18n                      from '../../../components/Translate/I18n';
import EditButton                from '../../../components/Buttons/EditButton';
import ActivateFeatureButton     from '../../../components/Buttons/ActivateFeatureButton';
import { withStyles }            from '@material-ui/core/styles';
import oplAppStyle               from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import PaperedTable              from '../../../components/Table/PaperedTable';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import {DateHelperTs} from "../../../helpers/DateHelperTs";
import Pager from "../../../components/Adescom/Pager";

interface DiscountTableInterface {
    classes: any;
    discounts: DiscountCollectionInterface | null;
    updateOrders: (orders: Array<Order>) => void;
    updateFilters: (filters: Array<Filter>) => void;
    filters: Array<Filter>;
    orders: Array<Order>;
    openAddDiscountModal?: () => void;
    search: () => void;
    clearFilters: () => void;
    editDiscount: (discount: DiscountInterface) => void;
    activateDiscount: (discount: DiscountInterface) => void;
    paginationCallback: (uri?: string) => void;
}

const DiscountTable = (props: DiscountTableInterface): React.ReactElement => {
    const {classes, paginationCallback} = props;
    const tableStickyHeader = {root: classes.tableStickyHeader};
    const tableCellRoot = { root: classes.tableCellRootBordered };

    return (
        <PaperedTable>
            <TableHead>
                <TableRow>
                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_DISCOUNT_POST) && (
                        <CustomTextButtom size={'sm'} callback={props.openAddDiscountModal} callbackParam={{}} label="discount:b.add_discount" />
                    )}
                </TableRow>
                <TableRow>
                    <div style={{ display: 'flex' }}>
                        <CustomTextButtom size={'sm'} callback={props.search} callbackParam={{}} label="general:common.search" />
                        {(props.filters.length > 0 || props.orders.length > 0) && (
                            <CustomTextButtom size={'sm'} callback={props.clearFilters} callbackParam={{}} label="general:common.clear_filter" />
                        )}
                    </div>
                </TableRow>
                <TableRow>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell textAlign="center" title="clients:c.commands" />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.name"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="mainname"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="string"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.value"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="amount"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="string"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.destination"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="type"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerCheckBoxSimpleList"
                            elementList={DiscountHelper.getTypesForDiscount()}
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.date_start"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="dateStart"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="date"
                            timeFormat={false}
                            dateFormat="RRRR-MM-DD"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.date_end"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="dateEnd"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="date"
                            timeFormat={false}
                            dateFormat="RRRR-MM-DD"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.grace_period"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="gracePeriod"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="date"
                            timeFormat={false}
                            dateFormat="RRRR-MM-DD"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.active"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="active"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="select"
                            selectComponent="headerBooleanCheckBoxSelectList"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} align="left">
                        <TableHeaderContentCell
                            textAlign="center"
                            title="discount:h.priority"
                            updateOrderList={props.updateOrders}
                            updateFilterList={props.updateFilters}
                            fieldName="priority"
                            showSort={true}
                            defaultDirection="desc"
                            searchFieldType="string"
                            filters={props.filters}
                            sort={props.orders}
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.discounts &&
                    props.discounts['hydra:member'] &&
                    props.discounts['hydra:member'].map((el: DiscountInterface) => {
                        return (
                            <TableRow key={el.id}>
                                <TableCell classes={tableCellRoot}>
                                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_DISCOUNT_PUT) && (
                                        <EditButton callback={props.editDiscount} callbackParam={el} tooltipTitle={'discount:b.edit'} />
                                    )}
                                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_DISCOUNT_PUT) && !el.active && (
                                        <ActivateFeatureButton
                                            callback={props.activateDiscount}
                                            callbackParam={el}
                                            tooltipTitle={'discount:b.activate'}
                                        />
                                    )}
                                </TableCell>
                                <TableCell classes={tableCellRoot}>{el.mainname}</TableCell>
                                <TableCell classes={tableCellRoot}>
                                    {[
                                        DiscountHelper.TYPES.TYPE_PROPORTIONATE_GLOBAL,
                                        DiscountHelper.TYPES.TYPE_PROPORTIONATE_PER_FRACTION,
                                        DiscountHelper.TYPES.TYPE_PROPORTIONATE_PER_PREFIX,
                                    ].includes(el.type) && el.count
                                        ? parseInt(el.count) / 100
                                        : el.count}
                                </TableCell>
                                <TableCell classes={tableCellRoot}>{<I18n trans={DiscountHelper.matchTypes(el.type)} />}</TableCell>
                                <TableCell classes={tableCellRoot}>{DateHelper.formatDDMMYYYY(el.dateStart)}</TableCell>
                                <TableCell classes={tableCellRoot}>{DateHelper.formatDDMMYYYY(el.dateEnd)}</TableCell>
                                <TableCell
                                    classes={tableCellRoot}>{DateHelper.formatDDMMYYYY(el.gracePeriod)}</TableCell>
                                <TableCell classes={tableCellRoot}>
                                    {!el.active || el.dateEnd < DateHelperTs.getCurentDate() ?
                                        <I18n trans={'general:common.No'}/> : <I18n trans={'general:common.Yes'}/>}
                                </TableCell>
                                <TableCell classes={tableCellRoot}>{el.priority}</TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={7}>
                        {props.discounts && props.discounts['hydra:view'] && (
                            <Pager callback={paginationCallback} views={props.discounts['hydra:view']}/>
                        )}
                    </TableCell>
                </TableRow>
            </TableFooter>
        </PaperedTable>
    );
};

export default withStyles(oplAppStyle)(DiscountTable);
